/**
 * SelectionTile CVA variants — border, background, shadow, and transition.
 *
 * Only variant and isSelected are in CVA. Alignment is a content-layout prop
 * passed to Flex and is not part of the tile shell styling.
 */

import { cva, type VariantProps } from 'class-variance-authority';

/** Base: border, shadow, and transition for border/background. All EDU tokens. */
export const selectionTileVariants = cva(
  'border-2 border-solid shadow-md transition-[border-color,background-color] duration-normal ease-in-out',
  {
    variants: {
      /** Selected-state border and background tint (primary or secondary). */
      variant: {
        primary: '!border-primary-700 !bg-primary-50',
        secondary: '!border-secondary-700 !bg-secondary-50',
      },
      /** When yes: use variant styles above. When no: transparent border, white bg, hover border. */
      isSelected: {
        yes: '',
        no: '!border-transparent !bg-white hover:!border-neutral-200',
      },
    },
    defaultVariants: {
      variant: 'secondary',
      isSelected: 'no',
    },
  },
);
